import React from 'react'
import generateContextProvider from '../../shared/hooks/GenerateContextProvider'
import { eqxAppConfigApi } from '../../shared/interfaces/eqxAppConfig'
import { useEnvironmentContext } from './AppEnvironment'

interface AppBaseConfig {
    name: string
    version: string
    api: eqxAppConfigApi
    auth: {
        scopes: string[]
    }
}

const ConfigWrapper = (props: {
    provider: React.FC<{ value: AppBaseConfig; children: React.ReactNode }>
    children: React.ReactNode
}) => {
    const env = useEnvironmentContext()
    const BaseConfigProvider = props.provider
    let url = process.env.REACT_APP_API_URL
    if (env.environment == 'staging') {
        url = process.env.REACT_APP_API_URL_STAGING
    }
    if (!url) {
        throw new Error('API URL is not set')
    }

    const config = {
        name: 'Operative Portal',
        version: '1.2.0',
        api: {
            baseUrl: url
        },
        auth: {
            scopes: ['openid', 'profile', 'api://d21cfa4d-73d7-4dd4-a152-0c4a8e3c5b78/access'],
        },
    }

    return <BaseConfigProvider value={config}>{props.children}</BaseConfigProvider>
}

const { ContextProvider: AppBaseConfigProvider, useContext: useBaseConfigContext } =
    generateContextProvider<AppBaseConfig>(undefined, ConfigWrapper)

export { AppBaseConfigProvider as default, useBaseConfigContext, type AppBaseConfig }

